export enum PaymentResultEnum {
  CANCELLED,
  FAILED,
  SUCCESS,
  ALREADY_PAID,
  IN_PROGRESS
}
